import { Chip, Tooltip, Typography, CircularProgress } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import { useVersion } from "../../../contexts/VersionContext";
import versionInfo from "../../../version.json";

function VersionBadge({ variant = "chip", sx = {} }) {
  const { isChecking, isUpdating, hasUpdate, checkForUpdates } = useVersion();
  const currentVersion = versionInfo.version || "0.1.0";
  const commit = versionInfo.commit || "dev";
  const buildDate = versionInfo.buildDate || "";

  const versionText = isChecking
    ? "Verificando..."
    : isUpdating
    ? "Atualizando..."
    : hasUpdate
    ? `v${currentVersion} (Atualizar)`
    : `v${currentVersion}`;

  const tooltipTitle = isChecking
    ? "Verificando se há atualizações no servidor..."
    : isUpdating
    ? "Baixando e aplicando a versão mais recente..."
    : hasUpdate
    ? "Nova versão disponível! Clique para atualizar agora."
    : `Versão ${currentVersion} (${commit}) • ${buildDate} — Clique para verificar atualizações`;

  const handleClick = (e) => {
    e.stopPropagation();
    checkForUpdates({ manual: true });
  };

  if (variant === "text") {
    return (
      <Tooltip title={tooltipTitle} arrow>
        <Typography
          variant="caption"
          color="text.secondary"
          onClick={handleClick}
          sx={{
            cursor: "pointer",
            userSelect: "none",
            fontSize: "0.75rem",
            whiteSpace: "nowrap",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            transition: "color 0.2s ease",
            "&:hover": {
              color: "primary.main",
            },
            ...sx,
          }}
        >
          {isChecking && <CircularProgress size={10} color="inherit" />}
          {versionText}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltipTitle} arrow>
      <Chip
        label={versionText}
        size="small"
        variant={hasUpdate ? "filled" : "outlined"}
        onClick={handleClick}
        icon={
          isChecking ? (
            <CircularProgress size={12} color="inherit" />
          ) : hasUpdate ? (
            <SyncIcon
              sx={{
                fontSize: "14px !important",
                animation: "spin 2s linear infinite",
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(360deg)" },
                },
              }}
            />
          ) : undefined
        }
        sx={{
          height: "22px",
          fontSize: "0.72rem",
          fontWeight: 600,
          borderColor: hasUpdate ? "#2e7d32" : "#d0d7de",
          color: hasUpdate ? "#ffffff" : "#424242",
          backgroundColor: hasUpdate ? "#2e7d32" : "#f6f8fa",
          cursor: "pointer",
          flexShrink: 0,
          whiteSpace: "nowrap",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: hasUpdate ? "#1b5e20" : "#ebeef2",
            borderColor: hasUpdate ? "#1b5e20" : "#bbb",
          },
          "& .MuiChip-label": {
            px: 0.8,
          },
          ...sx,
        }}
      />
    </Tooltip>
  );
}

export default VersionBadge;
